// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Xrvl","buttons":"RemoveExpirationActionButtons_buttons__3jrrg"};